import React from 'react';
import PropTypes from 'prop-types';
import CumulativeSalesChart from './CumulativeSalesChart';
import SalesChartLegend from './SalesChartLegend';
import './SalesPerformance.css';

const formatUSD = (amount) => {
  const n = Number(amount) || 0;
  return n.toLocaleString('en-US', { style: 'currency', currency: 'USD', minimumFractionDigits: 2, maximumFractionDigits: 2 });
};

const SalesPerformance = ({ salesData, cumulativeSalesData, forecastCurve, forecastRationale, capacity, todayDate }) => (
  <>
    <div className="mi-section-heading">
      <h2><span className="mi-section-num">2</span>Sales performance</h2>
    </div>
    <section className="mi-card">
      <div className="mi-card-header">
        <div>
          <h2 className="mi-card-title">Cumulative sales</h2>
        </div>
        <SalesChartLegend />
      </div>
      <div className="mi-sales-summary">
        <div className="mi-stats">
          <div className="mi-stat">
            <div className="mi-stat-label">Venue gross</div>
            <div className="mi-stat-value">{formatUSD(salesData?.gross)}</div>
          </div>
          <div className="mi-stat">
            <div className="mi-stat-label">Tickets gross</div>
            <div className="mi-stat-value">{formatUSD(salesData?.tickets)}</div>
          </div>
          <div className="mi-stat">
            <div className="mi-stat-label">Add-Ons gross</div>
            <div className="mi-stat-value">{formatUSD(salesData?.add_ons)}</div>
          </div>
          <div className="mi-stat">
            <div className="mi-stat-label">Royalties</div>
            <div className="mi-stat-value">{formatUSD(salesData?.royalties)}</div>
          </div>
        </div>
        <CumulativeSalesChart data={cumulativeSalesData} forecastCurve={forecastCurve} capacity={capacity} todayDate={todayDate} />
      </div>
      {forecastRationale && (
        <div style={{ padding: '0 24px 24px', fontSize: '12px', lineHeight: 1.5, color: 'var(--sl-text-tertiary)' }}>
          {forecastRationale}
        </div>
      )}
    </section>
  </>
);

SalesPerformance.propTypes = {
  salesData: PropTypes.shape({
    gross: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    tickets: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    add_ons: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    royalties: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  }),
  cumulativeSalesData: PropTypes.array,
  forecastCurve: PropTypes.array,
  forecastRationale: PropTypes.string,
  capacity: PropTypes.number,
  todayDate: PropTypes.string,
};

SalesPerformance.defaultProps = {
  salesData: null,
  cumulativeSalesData: [],
  forecastCurve: [],
  forecastRationale: null,
  capacity: 0,
  todayDate: null,
};

export default SalesPerformance;
